import MuiFormControlLabel from '@material-ui/core/FormControlLabel';
import MuiRadio from '@material-ui/core/Radio';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import React from 'react';
import { HIGHLIGHT, TEXT } from '../Colors';
import { BODY } from '../Fonts';

const StyledFormControlLabel = withStyles({
    root: {
        marginRight: '9px',
        color: TEXT,
        '& .MuiRadio-root': {
            color: TEXT
        },
        '& .MuiRadio-root.Mui-checked .MuiIconButton-label': {
            color: HIGHLIGHT,
        },
        '& .MuiFormControlLabel-label': {
            font: BODY,
            marginBottom: '2px',
            marginLeft: '-2px'
        },
        '& .MuiIconButton-label div svg:first-child': {
            color: TEXT
        },
    },
})(MuiFormControlLabel);

const useStyles = makeStyles({
    hidden: {
        display: 'none',
    }
});

interface RadioButtonProps {
    checked: boolean,
    label?: string,
    hidden?: boolean,
    disabled?: boolean,
    autoFocus?: boolean,
    stopPropagation?: boolean,
    onSelected?(): void
}

export const RadioButton: React.FunctionComponent<RadioButtonProps> = (props) => {
    const classes = useStyles();

    // "stylingClassName" is used for "styled components" extensions. It is hidden from the developer.
    const stylingClassName = (props as any).className ? (props as any).className : '';

    const onChange = (isChecked) => {
        if (props.onSelected && isChecked) {
            props.onSelected();
        }
    }

    const className = `${props.hidden ? classes.hidden : ''}  ${stylingClassName}`;

    return (
        <StyledFormControlLabel disabled={props.disabled} className={className} hidden={props.hidden}
            control={
                <MuiRadio
                    checked={props.checked !== false ? true : false}
                    onClick={e => { if (props.stopPropagation) e.stopPropagation(); }}
                    onChange={e => onChange(e.target.checked)}
                    autoFocus={props.autoFocus}
                    color="primary"
                />
            }
            label={props.label}
        />);
}